<template>
	<div class="investmentClues">
		<leftnav class="fl" mkcode="C" :itemcode="(curWebsite.type == 5 || curWebsite.type == 6)? 'C-YZSSGSPH':'C-GDXSTJ'"></leftnav> 
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<!-- 头部盒子开始 -->
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title" v-if="curWebsite.type != 5 && curWebsite.type != 6">{{curWebsite.keyword}}{{curWebsite.type == 2 ?'':'线索'}}</span>
						<span class="fl right_title" v-if="curWebsite.type == 5 || curWebsite.type == 6">产业排行榜</span>
						<cluetips></cluetips>
						<video-teaching :type="3" seat="top"></video-teaching>
						</div>
						<!-- 筛选项开始 -->
				<div class="opport-screen-list1">
				<div class="spage-searchbox ">
					<ClueNav tabCode="yzssgszs"></ClueNav>  
				</div>  
				<dl class="opport-screen bdbe" >
					<dt class="fl">上市板块</dt>
					<dd class="fl"> 
					<span :class="ipoType == item.code?'a-screen current':'a-screen'" @click="freeClick(1,item.code)" v-for="(item,i) in ipoTypeList" :key="'ipo'+i">{{item.name}}</span>
					</dd>
				</dl>
				<dl class="opport-screen bdbe" >
					<dt class="fl">省份地区</dt>
					<dd class="fl">
						<span :class="provinceid == 0?'current a-screen':'a-screen'"
							@click="provincechoose(0,'all');userdata.provinceText='全国地区';">全国地区</span>
						<span v-for="(item,index) in provincedata" :key="'province'+index"
							@click="provincechoose(item.areaId,index);userdata.provinceText=item.areaName;"
							:class="item.areaId == provinceid?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
					</dd>
				</dl>
				<dl class="opport-screen bdbe" v-show="citydata.length!=0">
					<dt class="fl">城市地区</dt>
					<dd class="fl">
						<span :class="cityid == 0?'current a-screen':'a-screen'"
							@click="choosecity(0,'all');userdata.cityText='';getclue()">全部</span>
						<span v-for="(item,index) in citydata" :key="'city'+index"
							@click="choosecity(item.areaId,index);cityid=item.areaId;userdata.cityText=item.name;getclue()"
							:data="item.areaId"
							:class=" item.areaId == cityid ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
					</dd>
				</dl>
				<dl class="opport-screen bdbe" >
					<dt class="fl">行业</dt>
					<dd class="fl">
					<span :class="(industryid == -1 || industryid == 0)?'a-screen current':'a-screen'" @click="freeClick(2,-1);">全部</span>
					<span :class="industryid == item.value?'a-screen current':'a-screen'" @click="freeClick(2,item.value);" v-for="(item,i) in industryoptions1" :key="item.name+i">{{item.name}}</span>
					</dd>
				</dl>
			</div>
			<!-- 筛选项结束 -->
			</div>
			<!-- 头部盒子结束 -->  
			<!-- 表格内容开始 -->
			<div class="whitebox"  >
				<div class="enterparise_guide oh" style="width: 95%; ">
					<p class="fl">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
				</div> 
			<!-- 上市公司招商线索 -->
			<div class="enterprise_list_box" >
				<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="provinceid == 0">
					<tr>
					<th v-if="industryid == -1 ">序号</th>
					<th>行业名称</th>
					<th>营业收入（亿元）<i :class="sort!=1 ? 'sort_ico' : 'sort_ico_up'" @click="getSort('enterprise',1)"></i></th>
					<th>营收增速<i  :class="sort!=2 ? 'sort_ico' : 'sort_ico_up'" @click="getSort('enterprise',2)"></i></th>
					<th>净利润（亿元）<i  :class="sort!=3 ? 'sort_ico' : 'sort_ico_up'" @click="getSort('enterprise',3)"></i></th>
					<th>净利增速 <i  :class="sort!=4 ? 'sort_ico' : 'sort_ico_up'" @click="getSort('enterprise',4)"></i></th>
					<th style="width: 120px;">-</th>
					</tr> 
					<tr v-for=" (list,i) in  industryAjaxList" :key="'industry'+i">
						<td v-if="industryid == -1 ">{{i+1}}</td>
						<td class="title" data="list.industryId">{{list.industryName}}</td>
						<td>{{list.lR0003}}</td>
						<td>{{list.lR0003Grow}}%</td>
						<td>{{list.lR0001}}</td>     
						<td>{{list.lR0001Grow}}%</td> 
						<td >-</td>
					</tr>
				</table>   
				<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="industryid!=-1">
					<tr>
						<th>排名</th>
						<th>企业名称</th>
						<th>营业收入（{{ipoType==1?'亿元':'万元'}}）<i :class="sort!=1 ? 'sort_ico' : 'sort_ico_up'" @click="getSort('enterprise',1)"></i></th>
						<th>营收增速<i :class="sort!=2 ? 'sort_ico' : 'sort_ico_up'" @click="getSort('enterprise',2)"></i></th>
						<th>净利润（{{ipoType==1?'亿元':'万元'}}）<i :class="sort!=3 ? 'sort_ico' : 'sort_ico_up'" @click="getSort('enterprise',3)"></i></th>
						<th>净利增速 <i :class="sort!=4 ? 'sort_ico' : 'sort_ico_up'" @click="getSort('enterprise',4)"></i></th>
					<!-- <th>投资意愿 <i class="sort_ico"  v-show="sort!=5" @click="sort=5;getclue()"></i><i class="sort_ico_up" @click="sort=5;getclue()" v-show="sort==5"></i></th> -->
					<th style="width: 120px;">编辑</th>
					</tr> 
					<tr v-for="(list,index) in ipolist" :key="'opolist'+index">
						<td>{{(page-1)*pageSize+index+1}}</td>
						<td class="title"  @click="routerlinkid('/enterprises',list.stockCode,2,'','all')" >{{list.title}}</td>  
						<td>{{list.lR0003}}</td>
						<td>{{list.lR0003Grow}}%</td>
						<td>{{list.lR0001}}</td>     
						<td>{{list.lR0001Grow}}%</td>  
						<!-- <td>
							<el-rate  v-model="list.investIntention" disabled show-score 	text-color="#0262de" 	:max="5" :colors="strcolors" score-template=""> </el-rate>
						</td>  -->
						<td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br/>目标企业</span></td> 
					</tr>
				</table>
			</div>
			<!-- 表格内容结束 -->
			<div class="centerpage1 company_pagelist" v-show="totalPage>1">
				<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
					v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
				</zpagenav>
			</div> 
			</div> 
			</div>
		</div>
	</div>
	</template>
	
	<script>
		import { dataInJs } from "../../utils/city.js";
		import { mapState, mapMutations, mapGetters } from "vuex";
	
		export default {
		  name: 'investmentClues',
		  computed: {
			...mapState({
				isCollapse: (state) => state.isCollapse,
			}),
			...mapGetters(['isCollapse'])
		},
				data(){return{      
					isShowFreeUserTips:false,
					notionlist:[],//用户初始概念数据     
					userdata:{},curWebsite:this.$api.getWebsiteType(), 
					ipoType:1,
					ipoTypeList:[{name:"主板",code:1},{name:"新三板",code:2}],
					searchtype:7,//线索类型 2以商招商 1本省投资概率 3关键融资 4优质企业  
					industryid:-1, 
					enterpristlist:[], 
					strcolors:['#3A66BE', '#3A66BE', '#3A66BE'],
					provincedata:dataInJs(),//省份城市数据
					countydata:[],
					citydata:[],
					provinceid:0,
					cityid:0, 
					countyid:0,
					industryoptions1:[],  
					industryAjaxList:[],//全部行业时的行业列表
					industryAjaxListDefault:[],//用于筛选的
					ipolist:[],//上市公司列表 
					page: 1,  //显示的是哪一页
					haspage:true,//是否还有下一页
					pageSize: 10, //每一页显示的数据条数
					total: 0, //记录总数 
					totalPage:1,
					maxPage:10,  //最大页数
					sort:5, //上市公司招商线索 排序 1营业收入 2营业增速 3净利润 4净利增速 5投资意愿 
				}},
				created() {
					this.$nextTick(() => {
							// 禁用右键
							document.oncontextmenu = new Function("event.returnValue=false");
							// 禁用选择
							document.onselectstart = new Function("event.returnValue=false");
						  });
				 var _this=this; 
					this.userdata =this.getuseriformation(); 
					_this.getindustry();
					this.$axios.get(this.$api.cyl.notion.list()+'?level=4',{headers:{AuthToken:this.userdata.token}}).then(function(res){
						if(res.data.success){    
							var ddds=[]; 
							// console.log(res.data)
							_this.notionlist=res.data.list == null ? []:res.data.list;      
						}else{ 
							
						} 
					}); 
				},
				mounted() { 
					document.getElementById('app').style.background = "#f0f3f5";
				 
					this.getclue(); 
					
					// this.getareaclue(this.pro);
				},
				methods: {
					freeClick(step,code){
						if(!this.userdata.token){
							this.isShowFreeUserTips = true;
							return;
						}
						if(step == 1){
							this.ipoType == code;
						}else if(step == 2){
							this.industryid=code;
						}
						this.getclue();
					},
					//排序名字选择
					getSort(type,sortid){
						if(!this.userdata.token){
							this.isShowFreeUserTips = true;
							return;
						}
						if(this.sort==sortid){
							return ;
						}
						this.sort=sortid;
						this.getclue();
					},
					//省份城市选择
					 provincechoose(id,i){ 
						if(!this.userdata.token){
							this.isShowFreeUserTips = true;
							return;
						}
							this.provinceid =id;this.cityid =0; this.countyid =0;
							this.countydata=[];
							if(id == 0 && this.industryid == 0){
								this.industryid=-1;
							}
							if(i!="all" && this.provincedata[i].children != null){
									this.citydata=this.provincedata[i].children;
							}else{
								this.citydata=[];
							} 
							this.page=1; 
							this.getclue();
						},
					choosecity(id,i){
						//	console.log('choosecity',id);
						this.cityid =id;this.countyid =0;
						if(i!="all" && this.citydata[i].children!= null){
								this.countydata=this.citydata[i].children;
						}else{
							this.countydata=[];
						} 
						this.page=1; 
						// this.ajaxsearchcompany(); 
					},  
					//获取行业分类
					getindustry(){  
							var _this=this;  
							this.$axios.get(this.$api.cyl.parameter.stockindustry(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
								console.log("行业分类",res);
								if(res.data.success){   
									_this.industryoptions1=res.data.list; 
								}
								else{ 
										
								} 
							}).catch(function (error) {
								// 请求失败处理 console.log(error);
							});  
							},
							notionlistnumber(namelist,codelist){
								// console.log(namelist,codelist); 
								for(var i=0;i<namelist.length;i++){ 
								 let arry2=namelist[i].children;
									for(var d=0;d<namelist[i].children.length;d++){ 
										for(var s=0;s<codelist.length;s++){
											if(namelist[i].children[d].value  == codelist[s].code){
												namelist[i].children[d].count=codelist[s].count;
											}
										} 
										//二级
										// console.log('q',namelist[i].children[d].label);
										if(namelist[i].children[d].children!=null){
											for(var f=0;f<namelist[i].children[d].children.length;f++){
												for(var s=0;s<codelist.length;s++){
													if(namelist[i].children[d].children[f].value  == codelist[s].code){
														namelist[i].children[d].children[f].count=codelist[s].count;
													}
												}
												// console.log('f',namelist[i].children[d].children[f].label);
												if(namelist[i].children[d].children[f].children!=null){
														for(var g=0;g<namelist[i].children[d].children[f].children.length;g++){
															for(var s=0;s<codelist.length;s++){
																if(namelist[i].children[d].children[f].children[g].value  == codelist[s].code){
																	namelist[i].children[d].children[f].children[g].count=codelist[s].count;
																}
															}
															// console.log('g',namelist[i].children[d].children[f].children[g].label); 
															//
														}  
												} 
												//
											}  
										}  
									 //
									} 
								};  
								this.notionlist=namelist;
							}, 
							//获取产业链/区域/融资企业招商线索
							getclue(pages){
								var _this=this,ajaxurl='',ajpage=1;
								_this.bus.$emit('loading', true);   
								this.page=pages?pages:1; 
								if(this.provinceid!=0 &&  this.industryid == -1){
									 this.industryid=0;
								} 
								ajaxurl=this.$api.cyl.investclue.ipo()+'?industry='+this.industryid+'&province='+this.provinceid+'&city='+this.cityid+'&order='+this.sort+'&type='+this.ipoType+'&page='+this.page;
									
									this.$axios.get(ajaxurl,{headers:{AuthToken:this.userdata.token}}).then(function(res){
									 
										console.log(ajaxurl);
										if(res.data.success){
											let pageindustryId=_this.industryid ;
											if(_this.industryid == -1){
												//行业选择为全部时  不显示企业列表 只显示行业列表
												_this.industryAjaxList = res.data.list;
												_this.industryAjaxListDefault=res.data.list;
													_this.ipolist = [];
												
											}else{
												_this.industryAjaxList=_this.industryAjaxListDefault.filter(list=>{
													return list.industryId == pageindustryId;
												})
												_this.ipolist = res.data.list;
												
												
											}
											
											
											
											 // _this.notionlistnumber(_this.notionlist,res.data.extend.notionList);	//悬浮导航概念筛选
											_this.bus.$emit('loading', false);
											_this.totalPage=res.data.totalPage;
											_this.pageSize=res.data.pageSize;  
											_this.total=res.data.totalRecord; 
										}
										else{ 
												
										} 
									}).catch(function (error) {
										// 请求失败处理 console.log(error);
									});  
									},
				 
					pageHandler: function(page) { 
						this.getclue(page);  
					},
			 
				},
		}
	</script>
	
	<style> 
	/* 提示框箭头 */
	.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
	  border-top-color: #E0E8F9;
	}
	.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
	  border-top-color: #E0E8F9;
	} 
	/* 提示框背景色 */
	.atooltip {
	  background: #E0E8F9 !important; 
	}
	 
	</style>
	